import React, { useState, useEffect } from 'react'
import { Alert, Button, Image } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import { useNavigate, useParams } from 'react-router'
import moment from 'moment-timezone'
import FontAwesomeIcon from '@severed-links/common.font-awesome-icon'
import * as s from './DeadlineAlertContainer.scss'
import { teamUrl } from '@severed-links/common.redherrings-constants'

const DeadlineAlertContainer = ({ deadline, teamId, teamName, avatarUrl, showPickButton = false, postseason = false, setPickTeamId, compact = false }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { seasonName } = useParams()
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), 10000)
    return () => clearInterval(timer)
  }, [])
  const due = moment(deadline)
  if (!deadline || !due.isValid() || moment(now).isSameOrAfter(due)) return null
  const urgent = due.diff(moment(now), 'minutes') <= 60
  const onClick = () => {
    if (moment().isSameOrAfter(due)) { setNow(Date.now()); return }
    if (setPickTeamId) dispatch(setPickTeamId(teamId))
    if (seasonName) navigate(`/football/${postseason ? 'postseason' : 'regular-season'}/${seasonName}/enter-picks`)
  }
  return (
    <Alert variant={urgent ? 'danger' : 'info'} className={`${s.container} ${compact ? s.compact : ''}`}>
      <div className={s.content}>
        {!compact && avatarUrl ? <div className={s.avatar}><Image src={teamUrl(avatarUrl)} alt='' /></div> : null}
        <div className={s.teamName}>
          <strong>{teamName}</strong> · Picks due {due.from(moment(now))}
          <div className={s.exactDeadline}>{due.format('ddd, MMM D · h:mm A z')}</div>
        </div>
        {showPickButton ? <div className={s.control}>
          <Button variant={urgent ? 'danger' : 'success'} onClick={onClick}>
            <FontAwesomeIcon name='check' />{' '}Enter picks
          </Button>
        </div> : null}
      </div>
    </Alert>
  )
}

export default DeadlineAlertContainer
